
<app-nav-bar/>
<app-all-imagenes/>
<app-footer-persona/>
